// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.system-role-list[data-v-75486c1e]{\n}\n.filter-container[data-v-75486c1e]{\n  position: relative;\n  margin-bottom: 38px;\n  text-align: right;\n}\n.search-frame[data-v-75486c1e] {\n  width: 160px;\n  margin-left: 5px;\n}\n.search-btn[data-v-75486c1e] {\n  margin-left: 10px;\n}\n.add-btn[data-v-75486c1e]{\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
